/* VialArt / VialCase — REAL material texture in previews + live sheen +
   SELF-HEALING CART. v5.
   - Overrides window.vaApplyMaterial: the SELECTED paper's photo backs the
     label; white fills become windows onto it (white = no ink = raw stock);
     white TEXT gets a brightened silvery variant; Aurora renders as
     silver-at-rest (base + softened photo) so no single hue dominates.
   - A light sweep animates across the big previews only.
   - CART: labels re-render on every cart visit from the CURRENT design
     template + CURRENT pipeline using the field values stored at confirm —
     so design/pipeline updates propagate to carts automatically. Logo lines
     keep their confirm-time snapshot (logo isn't stored). Print untouched.
   Identical file ships to BOTH themes. */
(function () {
  var IMGS = null, DATA = {}, orig = null, installed = false;
  var WORKER = 'https://vialart-design.vialart.workers.dev';
  /* physical die-cut corner radius, mm - both dies (see applyTex) */
  var VA_DIE_R = 3.175;

  var VAHW = {' ':278,'!':333,'"':474,'#':556,'$':556,'%':889,'&':722,"'":238,'(':333,')':333,'*':389,'+':584,',':278,'-':333,'.':278,'/':278,'0':556,'1':556,'2':556,'3':556,'4':556,'5':556,'6':556,'7':556,'8':556,'9':556,':':333,';':333,'<':584,'=':584,'>':584,'?':611,'@':975,'A':722,'B':722,'C':722,'D':722,'E':667,'F':611,'G':778,'H':722,'I':278,'J':556,'K':722,'L':611,'M':833,'N':722,'O':778,'P':667,'Q':778,'R':722,'S':667,'T':611,'U':722,'V':667,'W':944,'X':667,'Y':667,'Z':611,'[':333,'\\':278,']':333,'^':584,'_':556,'`':333,'a':556,'b':611,'c':556,'d':611,'e':556,'f':333,'g':611,'h':611,'i':278,'j':278,'k':556,'l':278,'m':889,'n':611,'o':611,'p':611,'q':611,'r':389,'s':556,'t':333,'u':611,'v':556,'w':778,'x':556,'y':556,'z':500,'{':389,'|':280,'}':389,'~':584};

  function texUrl(cls) {
    try {
      var el = document.createElement('span');
      el.className = cls;
      el.style.cssText = 'position:absolute;left:-9999px;top:-9999px;width:4px;height:4px;';
      document.body.appendChild(el);
      var bg = getComputedStyle(el).backgroundImage || '';
      el.parentNode.removeChild(el);
      var m = bg.match(/url\(["']?([^"')]+)["']?\)/);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }
  function resolveImgs() {
    var a = texUrl('sw sw-aurora') || texUrl('sw-aurora');
    var p = texUrl('sw sw-prism') || texUrl('sw-prism');
    if (a && p) return { aurora: a, prism: p };
    return null;
  }
  function esc(u) { return String(u).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }
  function escText(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function prepData(key, url) {
    try {
      var im = new Image();
      im.onload = function () {
        try {
          var S = im.naturalWidth || 420;
          var c = document.createElement('canvas');
          c.width = S; c.height = S;
          c.getContext('2d').drawImage(im, 0, 0, S, S);
          DATA[key] = c.toDataURL('image/jpeg', 0.92);
        } catch (e) {}
      };
      im.src = url;
    } catch (e) {}
  }

  /* ---- shared texturizer (used by the live override AND the cart heal) ---- */
  function applyTex(svg, matName, useData) {
    if (!IMGS || !svg || svg.indexOf('<svg') < 0) return svg;
    var m = svg.match(/viewBox\s*=\s*["']\s*[\d.+-]+\s+[\d.+-]+\s+([\d.]+)\s+([\d.]+)/);
    var W = m ? parseFloat(m[1]) : 44.958, H = m ? parseFloat(m[2]) : 19.05;
    var dieR = Math.min(VA_DIE_R, W / 2, H / 2);
    /* PREVIEWS ARE PINNED TO AURORA (owner 2026-07-27). The Shattered Prism
       photo reads as cracked noise on screen and hurt conversion, while the
       printed label looks far better than any preview of it. So EVERY preview
       surface — builder, gallery tiles, cart thumbnails — renders the Aurora
       texture regardless of the material selected. The material picker still
       sells Prism (its swatch chip shows the real photo) and the ORDER still
       carries the true material; only the preview texture is pinned. Selecting
       Prism deliberately does NOT change the preview. To ever undo this,
       restore the commented test below — do not re-derive it.
       // var prism = /prism|shatter/i.test(matName || 'Aurora'); */
    var prism = false;
    /* 2026-10-17 owner: Gloss White on the 10 mL press, $0.99 under holo: white stock previews as plain white - no holo texture behind the art */
    var white = /white/i.test(String(matName || ''));
    var key = prism ? 'prism' : 'aurora';
    var href = esc((useData && DATA[key]) ? DATA[key] : IMGS[key]);
    var iw = prism ? W : W * 1.4;
    var ix = prism ? 0 : -9;
    var iy = prism ? -(W - H) / 2 : -2;
    /* 2026-07-23: the "physically accurate at-rest" desaturation (saturate 0.3)
       made Shattered Prism preview as flat gray next to Aurora's color — sales
       slid 32% -> 17% of jobs in three weeks. 5-JUDGE PANEL VERDICT 2026-07-23
       (vs the owner's real-label photo + his rejected busy-gallery shot):
       base texture at SATURATE 0.6 — silver-first with muted color hints
       (0.3 read flat gray and killed sales; 1.0 read rainbow confetti and
       drowned the gallery). Do not retune without re-running the panel. */
    var imOp = prism ? '0.85' : '0.5';
    var imFilter = prism ? ' filter="url(#vaDesat)"' : '';
    var defs = '<defs>'
      + '<filter id="vaDesat"><feColorMatrix type="saturate" values="0.6"/></filter>'
      + '<pattern id="vaMatTex" patternUnits="userSpaceOnUse" x="0" y="0" width="' + W + '" height="' + H + '">'
      + '<rect width="' + W + '" height="' + H + '" fill="' + (white ? '#ffffff' : '#e9ebf2') + '"/>'
      + (white ? '' : '<image' + imFilter + ' href="' + href + '" xlink:href="' + href + '" x="' + ix + '" y="' + iy.toFixed(2) + '" width="' + iw.toFixed(2) + '" height="' + iw.toFixed(2) + '" preserveAspectRatio="xMidYMid slice" opacity="' + imOp + '"/>')
      + '</pattern>'
      + '<pattern id="vaMatTexT" patternUnits="userSpaceOnUse" x="0" y="0" width="' + W + '" height="' + H + '">'
      + '<rect width="' + W + '" height="' + H + '" fill="' + (white ? '#ffffff' : '#eef1f7') + '"/>'
      + (white ? '' : '<image' + imFilter + ' href="' + href + '" xlink:href="' + href + '" x="' + ix + '" y="' + iy.toFixed(2) + '" width="' + iw.toFixed(2) + '" height="' + iw.toFixed(2) + '" preserveAspectRatio="xMidYMid slice" opacity="0.88"/>')
      + '<rect width="' + W + '" height="' + H + '" fill="#ffffff" opacity="0.15"/>'
      + '</pattern>'
      + '<linearGradient id="vaGlossG" x1="0" y1="0" x2="0.9" y2="1">'
      + '<stop offset="0" stop-color="#ffffff" stop-opacity="0.16"/>'
      + '<stop offset="0.32" stop-color="#ffffff" stop-opacity="0.02"/>'
      + '<stop offset="0.6" stop-color="#ffffff" stop-opacity="0.1"/>'
      + '<stop offset="1" stop-color="#ffffff" stop-opacity="0.03"/>'
      + '</linearGradient>'
      + '<linearGradient id="vaSheenG" x1="0" y1="0" x2="1" y2="0">'
      + '<stop offset="0" stop-color="#ffffff" stop-opacity="0"/>'
      + '<stop offset="0.3" stop-color="#ffe9b8" stop-opacity="0.16"/>'
      + '<stop offset="0.45" stop-color="#ffffff" stop-opacity="0.3"/>'
      + '<stop offset="0.55" stop-color="#cfe6ff" stop-opacity="0.26"/>'
      + '<stop offset="0.7" stop-color="#f6d5ff" stop-opacity="0.14"/>'
      + '<stop offset="1" stop-color="#ffffff" stop-opacity="0"/>'
      + '</linearGradient>'
      /* DIE-CUT CORNERS (owner 2026-09-13, Navy Molecule 10 mL). The stock is
         cut with a 3.175 mm (1/8") corner radius on BOTH dies (Label Farm
         label_printers media_layout.corner_radius_in = 0.125; the press masks
         the art at exactly that radius). A CSS border-radius in px on the
         <img>/<svg> cannot follow that shape at every size - in the lightbox
         it was far tighter than the template's own corner arcs and a wedge of
         bare stock showed between them. So the proof carries the die shape
         itself: base, artwork and sheen are all clipped to it below. */
      + '<clipPath id="vaDie"><rect x="0" y="0" width="' + W + '" height="' + H + '" rx="' + dieR + '" ry="' + dieR + '"/></clipPath>'
      + '</defs>';
    /* embedded artwork (Background Studio designs): the bitmap's white pixels
       are unprinted = backing paper. multiply = the physical CMYK-ink model:
       white -> pure substrate, inks darken/tint it. Runs BEFORE our pattern
       defs are injected, so the texture images are never affected. */
    if (svg.indexOf('mix-blend-mode:multiply') < 0) {
      svg = svg.replace(/<image /g, '<image style="mix-blend-mode:multiply" ');
    }
    /* the printer has NO white ink — ANY white/near-white fill physically
       becomes backing paper, so swap by LUMINANCE (>=240), not exact match */
    function isPaper(col) {
      if (/^white$/i.test(col) || /^#fff$/i.test(col)) return true;
      if (/^#[0-9a-fA-F]{6}$/.test(col)) {
        var r = parseInt(col.slice(1, 3), 16), g = parseInt(col.slice(3, 5), 16), b = parseInt(col.slice(5, 7), 16);
        return (0.299 * r + 0.587 * g + 0.114 * b) >= 240;
      }
      return false;
    }
    var out = svg
      .replace(/(<(?:text|tspan)[^>]*?fill=")(#[0-9a-fA-F]{3,6}|white)(")/gi, function (m0, a, col, z) {
        return isPaper(col) ? a + 'url(#vaMatTexT)' + z : m0;
      })
      .replace(/fill="(#[0-9a-fA-F]{3,6}|white)"/gi, function (m0, col) {
        return isPaper(col) ? 'fill="url(#vaMatTex)"' : m0;
      });
    if (out.indexOf('xmlns:xlink') < 0) {
      out = out.replace(/<svg\b/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
    }
    var base = '<rect width="' + W + '" height="' + H + '" fill="url(#vaMatTex)"/>';
    var gi = out.indexOf('>', out.indexOf('<svg')) + 1;
    /* the clip group is only opened when there is a </svg> to close it at */
    var dieOn = out.lastIndexOf('</svg>') > -1;
    out = out.slice(0, gi) + defs + (dieOn ? '<g clip-path="url(#vaDie)">' : '') + base + out.slice(gi);
    /* OVERLAY REMOVED 2026-07-26 (owner: the shattered-ice preview kills
       conversion). Neither material now paints anything OVER the label face —
       the artwork is the only thing on it.
       History, so nobody re-adds this by reflex: a 0.12-opacity screen-blended
       cracked-ice accent sat here from 2026-07-23 (0.34 first, which washed the
       art out). Aurora never had an overlay.
       ⚠ The BASE texture below is a SEPARATE thing and is still in place at
       saturate 0.6 — do NOT also strip that. Desaturating the base to 0.3 in
       July took Shattered Prism from 32% to 17% of jobs in three weeks; the
       silver-first base is what makes the stock read as real holo. */
    var glow = '';
    var sweep = '<g class="va-sheen" opacity="0" style="mix-blend-mode:screen">'
      + '<rect x="-22" y="-6" width="11" height="' + (H + 12) + '" fill="url(#vaSheenG)" transform="skewX(-16)"/>'
      + '</g>';
    var ei = out.lastIndexOf('</svg>');
    if (ei > -1) out = out.slice(0, ei) + glow + sweep + (dieOn ? '</g>' : '') + out.slice(ei);
    return out;
  }

  function ensureCss() {
    if (document.getElementById('va-sheen-css')) return;
    var st = document.createElement('style');
    st.id = 'va-sheen-css';
    st.textContent =
      '@keyframes vaSweep{0%{transform:translateX(0)}55%{transform:translateX(96px)}100%{transform:translateX(96px)}}'
      + '.va-sheen{opacity:0;}'
      + '#va-flatlabel .va-sheen,#va-flatlabel2 .va-sheen,.va-s2pv .va-sheen,'
      + '.va-xp-thumb .va-sheen,.va-ordersum .va-sheen,.os-thumb .va-sheen{'
      + 'opacity:1;animation:vaSweep 5.2s cubic-bezier(.45,.05,.35,1) infinite;}'
      + '@media (prefers-reduced-motion:reduce){.va-sheen{animation:none!important;opacity:0!important;}}';
    document.head.appendChild(st);
  }

  function install() {
    if (installed) return true;
    if (typeof window.vaApplyMaterial !== 'function' || !document.body) return false;
    IMGS = resolveImgs();
    if (!IMGS) return false;
    try { localStorage.setItem('va_tex', JSON.stringify(IMGS)); } catch (e) {}
    ensureCss();
    prepData('aurora', IMGS.aurora);
    prepData('prism', IMGS.prism);
    orig = window.vaApplyMaterial;
    window.vaApplyMaterial = function (svg, d) {
      try {
        var mat = (typeof window.buyMat !== 'undefined' && window.buyMat) || 'Aurora';
        var out = applyTex(svg, mat, !!window.__vaCapTex);
        return out || svg;
      } catch (e) {
        try { return orig(svg, d); } catch (e2) { return svg; }
      }
    };
    installed = true;
    try { if (typeof window.buildDesignUI === 'function') window.buildDesignUI(); } catch (e) {}
    try { if (typeof window.renderAll === 'function') window.renderAll(); } catch (e) {}
    return true;
  }

  var tries = 0;
  (function tick() {
    if (install() || tries++ > 40) return;
    setTimeout(tick, 250);
  })();

  /* =================== SELF-HEALING CART PREVIEWS ===================
     On /cart, re-render each label line from the CURRENT template with the
     field values saved at confirm — design edits and pipeline updates reach
     returning customers automatically. */
  if (location.pathname.indexOf('/cart') !== 0) return;

  function myAssetBase() {
    var sc = document.querySelector('script[src*="va-material-tex"]');
    if (!sc) return null;
    return sc.src.split('?')[0].replace(/va-material-tex[^/]*$/, '');
  }
  function loadQrLib(cb) {
    if (typeof window.qrcode !== 'undefined') { cb(true); return; }
    var base = myAssetBase();
    if (!base) { cb(false); return; }
    var s = document.createElement('script');
    s.onload = function () { cb(typeof window.qrcode !== 'undefined'); };
    s.onerror = function () { cb(false); };
    s.src = base + 'qrcode.js';
    document.head.appendChild(s);
  }

  function fitCompound(svg, text) {
    if (!text) return svg;
    return svg.replace(/<text\b([^>]*)>\s*\{\{\s*(?:peptide_name|compound)\s*\}\}\s*<\/text>/, function (m0, attrs) {
      var fm = attrs.match(/font-size="([\d.]+)"/);
      if (!fm) return m0;
      var fs0 = parseFloat(fm[1]);
      var scale = 1, sm = attrs.match(/scale\(\s*([\d.]+)/g);
      if (sm) { sm.forEach(function (x) { var k = parseFloat(x.replace(/scale\(\s*/, '')); if (k > 0) scale *= k; }); }
      var dfm = attrs.match(/data-fit="([\d.]+)"/);
      var avail = dfm ? parseFloat(dfm[1]) : 26;
      var wm = attrs.match(/font-weight="(\d+)"/);
      var wgt = wm ? parseInt(wm[1], 10) : 400;
      var infl = wgt >= 800 ? 1.12 : (wgt >= 700 ? 1.05 : 1.0);
      var em = 0;
      for (var i = 0; i < text.length; i++) { var ch = text.charAt(i); em += (VAHW.hasOwnProperty(ch) ? VAHW[ch] : 600); }
      em = em / 1000;
      var budget = avail * 0.97;
      var w = em * scale * infl;
      var fs = (w <= 0 || w * fs0 <= budget) ? fs0 : Math.max(1.4, Math.round(budget / w * 1000) / 1000);
      if (fs === fs0) return m0;
      return m0.replace(/font-size="[\d.]+"/, 'font-size="' + fs + '"');
    });
  }

  function renderQrInto(svg, url) {
    var m = svg.match(/<rect\b[^>]*\bdata-qr="\{\{\s*qr\s*\}\}"[^>]*\/>/);
    if (!m) return svg;
    var rect = m[0];
    function a(n) { var mm = rect.match(new RegExp('\\b' + n + '="([\\-\\d.]+)"')); return mm ? parseFloat(mm[1]) : 0; }
    var x = a('x'), y = a('y'), w = a('width'), h = a('height');
    url = String(url || '').trim() || 'https://vialart.com';
    if (w <= 0 || h <= 0 || typeof window.qrcode === 'undefined') {
      /* no lib: leave an unprinted (stock) patch instead of a token */
      return svg.slice(0, m.index) + '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="#ffffff"/>' + svg.slice(m.index + rect.length);
    }
    var qr;
    try { qr = window.qrcode(0, 'M'); qr.addData(url); qr.make(); } catch (e) { return svg; }
    var n = qr.getModuleCount(), quiet = 2, total = n + 2 * quiet, side = Math.min(w, h), cell = side / total;
    var ox = x + (w - side) / 2 + quiet * cell, oy = y + (h - side) / 2 + quiet * cell, d = '';
    for (var r = 0; r < n; r++) { for (var c = 0; c < n; c++) { if (qr.isDark(r, c)) { d += 'M' + (ox + c * cell).toFixed(3) + ' ' + (oy + r * cell).toFixed(3) + 'h' + cell.toFixed(3) + 'v' + cell.toFixed(3) + 'h-' + cell.toFixed(3) + 'z'; } } }
    var tfm = rect.match(/\btransform="([^"]*)"/);
    var tfA = tfm ? (' transform="' + tfm[1] + '"') : '';
    var g = '<g' + tfA + '><rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="#ffffff"/><path d="' + d + '" fill="#000000"/></g>';
    return svg.slice(0, m.index) + g + svg.slice(m.index + rect.length);
  }

  function healRender(raw, b) {
    var out = raw;
    var el = (b.epfx == null ? 'EXP' : b.epfx);
    out = out.replace(/LOT\s*[:\-]?\s*(\{\{\s*lot\s*\}\})/gi, '$1');
    out = out.replace(/EXP\s*[:\-]?\s*(\{\{\s*exp\s*\}\})/gi, el ? (el + ': $1') : '$1');
    out = fitCompound(out, b.name || '');
    out = renderQrInto(out, b.qr || '');
    ['lot', 'exp'].forEach(function (tok) {
      var val = tok === 'lot' ? b.lot : b.exp;
      if (String(val || '').trim()) return;
      out = out.replace(new RegExp('(<rect[^>]*\\/>\\s*)?<text[^>]*>[^<]*\\{\\{\\s*' + tok + '\\s*\\}\\}[^<]*<\\/text>', 'g'), '');
    });
    var dm = String(b.dose || '').match(/^\s*([\d.]+)\s*(.*)$/);
    var t = {
      peptide_name: escText(b.name), compound: escText(b.name),
      dose: escText(b.dose), dose_num: escText(dm ? dm[1] : (b.dose || '')), dose_unit: escText(dm && dm[2] ? dm[2] : 'mg'),
      vial_size: escText(b.vial), vial: escText(b.vial),
      lot: escText(b.lot), exp: escText(b.exp),
      administration: '', reconstitute: '', research_text: 'Research Use Only',
      color_name: '', color_hex: (String(b.color || '').match(/^#[0-9A-Fa-f]{6}$/) ? b.color : '#5b3aa8')
    };
    out = out.replace(/\{\{\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*\}\}/g, function (_, k) {
      return Object.prototype.hasOwnProperty.call(t, k) ? t[k] : '';
    });
    return applyTex(out, b.mat || 'Aurora', false);
  }

  function heal() {
    try { IMGS = IMGS || JSON.parse(localStorage.getItem('va_tex') || 'null'); } catch (e) {}
    if (!IMGS) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var lines = (cart.items || []).filter(function (it) {
        var p = it.properties || {};
        return p._template && p._template !== 'custom_upload';
      });
      if (!lines.length) return;
      loadQrLib(function () {
        lines.forEach(function (it) {
          var blob = null;
          try { blob = JSON.parse(localStorage.getItem('va_lp_' + it.key) || 'null'); } catch (e) {}
          if (!blob || blob.lg || !blob.name) return;      // no data / logo line -> keep snapshot
          var tpl = it.properties._template || blob.tpl;
          if (!tpl) return;
          fetch(WORKER + '/labels/svg/' + encodeURIComponent(tpl) + '?heal=1', { cache: 'no-store' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (raw) {
              if (!raw || raw.indexOf('<svg') < 0) return;
              var svg = healRender(raw, blob);
              if (!svg || svg.indexOf('<svg') < 0) return;
              /* paint (replace whatever the theme painted for this row) */
              var row = document.querySelector('[data-key="' + it.key + '"]');
              var media = row && row.querySelector('.cart-items__media');
              if (media) {
                media.innerHTML = '<div class="va-cart-media"><div class="va-cart-thumb va-cart-svg" role="img" aria-label="Your label design">' + svg + '</div></div>';
              }
              blob.svg = svg; blob.img = '';
              try { localStorage.setItem('va_lp_' + it.key, JSON.stringify(blob)); } catch (e) {}
            }).catch(function () {});
        });
      });
    }).catch(function () {});
  }

  var ht = 0;
  (function hwait() {
    /* run after the theme's own cart painter has done its pass */
    if (document.querySelector('.va-cart-media') || ht > 24) { setTimeout(heal, 400); return; }
    ht++; setTimeout(hwait, 350);
  })();
})();
